import Swiper, { Navigation } from 'swiper'
import { assign } from 'lodash';
import { sendVisibleCarouselItemsListScriptToGTM } from './shop-google-analytics';


export interface ICarousel {
    width?: number;
    containerClass: string;
    slidesPerView?: number;
    centeredSlides?: boolean;
    breakpoints?: any;
    spaceBetween?: number;
    navigation?: any;
    autoHeight?: boolean;
    height?: number;
    loop?: boolean;
    autoplayVideo?: boolean;
    pageNumberPreposition?: string;
    watchSlidesVisibility?: boolean;
}

export class ProductCarousel {
    //these params are exposed to the file you intialize your carousel in, so you can initialize multiple
    //carousel versions across your project or just be able to configure without diving into this file
    params: ICarousel = {
        containerClass: 'adage-carousel-js',
        centeredSlides: false,
        slidesPerView: 1,
        watchSlidesVisibility: true,
        breakpoints: {
            320: {
                spaceBetween: 16,
                slidesPerView: 2
            },
            640: {
                spaceBetween: 33,
                slidesPerView: 3
            },
            800: {
                spaceBetween: 33,
                slidesPerView: 4
            },
            1400: {
                spaceBetween: 33,
                slidesPerView: 5
            },
            1920: {
                spaceBetween: 33,
                slidesPerView: 6
            }
        },
        spaceBetween: 25,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        loop: false,
        autoplayVideo: true,
        pageNumberPreposition: ' of ',
        autoHeight: true
    };
    productCarousel: any;
    activeSlide: any;
    previousSlide: any;
    activeIndex: any;
    previousIndex: number; // swiper's previousindex implementation doesn't work with loop: true so we need to do it manually
    videos: any;
    carouselId: string;
    productData: any;

    constructor(params?: ICarousel) {

        assign(this.params, params);
        Swiper.use([Navigation]);
        this.productCarousel = new Swiper(`.${this.params.containerClass}`, {
            slidesPerView: this.params.slidesPerView,
            centeredSlides: this.params.centeredSlides,
            spaceBetween: this.params.spaceBetween,
            breakpoints: this.params.breakpoints,
            navigation: this.params.navigation,
            watchSlidesVisibility: true,
            
            loop: this.params.loop,
            on: {
                afterInit: this.sendVisibleItemsToGoogleTagManager.bind(this),
                slideChange: this.sendVisibleItemsToGoogleTagManager.bind(this)
            },
            enabled: true,
            autoHeight: this.params.autoHeight
        });
        if (this.productCarousel.el) {
            this.carouselId = this.productCarousel.el.getAttribute('data-unique-id');
        }
        this.videos = {};
        this.initCallback();
        setTimeout(() => this.productCarousel.resize.resizeHandler(), 2000); // SUPER hack... but it works
    }

    initCallback() {
        this.activeSlide = this.productCarousel.slides[this.productCarousel.activeIndex];
        this.activeIndex = this.productCarousel.activeIndex;
        this.setPageNumbers();
    }

    setPageNumbers() {
        if (this.productCarousel) {
            let totalSlides = this.productCarousel.el.getAttribute('data-total-slides');
            for (let i = 0; i < this.productCarousel.slides.length; i++) {
                let slide = this.productCarousel.slides[i];
                this.reconcileDupeId(slide);
                if (i !== this.activeIndex) {
                    this.disableSlide(slide);
                }
                let slidePageContainer = slide.querySelector('[data-carousel-page]');
                if (slidePageContainer) {
                    let pageString = `${parseInt(slide.getAttribute('data-slide-index')) + 1}${this.params.pageNumberPreposition}${totalSlides}`;
                    slidePageContainer.innerHTML = pageString;
                }
            }

        }
    }

    reconcileDupeId(slide) {
        // check to see if there's 2 slides with same unique ID (when loop is true, slides get duplicated)
        if (slide.querySelector('[data-unique-id]')) {
            let thisId = slide.querySelector('[data-unique-id]').getAttribute('data-unique-id');
            if (this.productCarousel.el.querySelectorAll(`[data-unique-id="${thisId}"]`).length > 1) {
                let dupes = Array.prototype.slice.call(this.productCarousel.el.querySelectorAll(`[data-unique-id="${thisId}"]`));
                dupes.forEach((dupe, index) => {
                    dupe.setAttribute('data-unique-id', `${thisId}-${index}`);
                })
            }
        }
    }

    handleSlide() {
        if (this.productCarousel) {
            this.previousSlide = this.activeSlide;
            this.previousIndex = this.activeIndex;
            this.activeSlide = this.productCarousel.slides[this.productCarousel.activeIndex];
            this.activeIndex = this.productCarousel.activeIndex;
            this.disableSlide(this.previousSlide);
            this.enableSlide(this.activeSlide);
        }
    }

    disableSlide(slide) {
        // disable tabbing on tabbable content by default to stop trapping keyboard, and hide from screenreader users
        let tabbableContent = Array.prototype.slice.call(slide.querySelectorAll('a, input, button, area, object, select, iframe, video, audio'));
        tabbableContent.forEach(item => {
            item.tabIndex = -1;
        });
        slide.setAttribute('aria-hidden', 'true');
    }

    enableSlide(slide) {
        // enable tabbing on active slide and show to screenreader users
        let tabbableContent = Array.prototype.slice.call(slide.querySelectorAll('a, input, button, area, object, select, iframe, video, audio'));
        tabbableContent.forEach(item => {
            item.tabIndex = 0;
        });
        slide.setAttribute('aria-hidden', 'false');
    }

    sendVisibleItemsToGoogleTagManager() {
        const carouselElement = document.querySelector("." + this.params.containerClass);
        sendVisibleCarouselItemsListScriptToGTM(carouselElement);
    }
}